import { render } from "./MenuControl.vue?vue&type=template&id=2db8ac8d"
import script from "./MenuControl.vue?vue&type=script&lang=js"
export * from "./MenuControl.vue?vue&type=script&lang=js"

import "./MenuControl.vue?vue&type=style&index=0&id=2db8ac8d&lang=css"

import exportComponent from "C:\\Mobile\\registration\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__